import {
  AdditionalApplianceFieldItem,
  AdditionalAppliancesField,
} from '../../models/appliance-details-additional-appliances/appliance-details-additional-appliances-field.interface';

export const mockAdditionalAppliancesField: AdditionalAppliancesField = {
  Dishwasher: '',
};

export const mockAdditionalApplianceFieldItem: AdditionalApplianceFieldItem = {
  label: 'Dishwasher',
  value: 'DW',
};
